import { render, staticRenderFns } from "./ImportDetail.vue?vue&type=template&id=18823732&scoped=true"
import script from "./ImportDetail.vue?vue&type=script&lang=js"
export * from "./ImportDetail.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=18823732&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18823732",
  null
  
)

export default component.exports